module.exports = __webpack_public_path__ + "img/case-3.1c180cb3.png";